import {useState} from "react";
import {Button} from "react-bootstrap";

export function CopyButton({text, label = 'Copy'}: { text: string, label?: string }) {
    const [copied, setCopied] = useState(false);
    const copy = async () => {
        try {
            await navigator.clipboard.writeText(text);
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        } catch {
            // Clipboard refused (insecure context or permission): the text is still selectable.
        }
    };
    return (
        <Button size="sm" variant="outline-secondary" onClick={copy} title={label}>
            <i className={`bi ${copied ? 'bi-check-lg' : 'bi-clipboard'}`}></i>
            <span className="visually-hidden">{label}</span>
        </Button>
    );
}
